import {Component} from '@angular/core';

@Component({
  selector: 'app-advanced-loader',
  templateUrl: 'loading.component.html',
  styleUrls: ['loading.component.less']
})
export class LoadingComponent {}
